// @ts-nocheck
// Greif UI Kit = line-plus
import { IconOffset } from "@toolkit/Framework/Types/Icon";
import * as React from "react";

const Plus: React.FC = () => {
    /* Store Custom Code - Start */
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M18 12.733H5.867a.867.867 0 1 1 0-1.733H18a.867.867 0 1 1 0 1.733"
                clipRule="evenodd"
            />
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12.8 5.8v12.133a.867.867 0 1 1-1.733 0V5.8a.867.867 0 1 1 1.733 0"
                clipRule="evenodd"
            />
        </svg>
    );
    /* Store Custom Code - End */
};

export const PlusOffset: IconOffset = {
    vertical: 20, // Store Custom Code
    horizontal: 20, // Store Custom Code
};

export default React.memo(Plus);
